import { render } from "./App.vue?vue&type=template&id=38125d9e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=38125d9e&lang=scss"

import exportComponent from "D:\\McToWebsite\\www\\CustomerWork\\XiJiangDairy\\OfficialWebsite\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__